import type { PaginationProps } from "../lib/types";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../ui/pagination";

interface PaginationSuiteProps {
  currentPage: number;
  totalPages: number;
  onPageChange?: (page: number) => void;
  className?: string;
}

export function PaginationSuite({
  currentPage,
  totalPages,
  // onPageChange,
  className,
}: PaginationSuiteProps) {
  const getVisiblePages = () => {
    const delta = 1;
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, "...");
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push("...", totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const visiblePages = getVisiblePages();
  const finalParams = (page: number | string) => {
    if (typeof window === "undefined") return `?page=${page}`;
    const params = new URLSearchParams(window.location.search);
    params.set("page", page.toString());
    return `?${params.toString()}`;
  };

  if (totalPages <= 1) return null;

  return (
    <Pagination className={className}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href={finalParams(currentPage - 1)}
            // onClick={(e) => {
            //   e.preventDefault();
            //   if (currentPage > 1) onPageChange?.(currentPage - 1);
            // }}
            className={currentPage <= 1 ? "pointer-events-none opacity-50" : ""}
          />
        </PaginationItem>

        {visiblePages.map((page, index) => (
          <PaginationItem key={index}>
            {page === "..." ? (
              <PaginationEllipsis />
            ) : (
              <PaginationLink
                href={finalParams(page)}
                // onClick={(e) => {
                //   e.preventDefault();
                //   onPageChange?.(page as number);
                // }}
                isActive={currentPage === page}
              >
                {page}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}

        <PaginationItem>
          <PaginationNext
            href={finalParams(currentPage + 1)}
            // onClick={(e) => {
            //   e.preventDefault();
            //   if (currentPage < totalPages) onPageChange?.(currentPage + 1);
            // }}
            className={
              currentPage >= totalPages ? "pointer-events-none opacity-50" : ""
            }
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}

export function PaginationFooter({
  pagination,
}: {
  pagination?: PaginationProps | null;
}) {
  if (!pagination) return null;
  const { currentPage, pageSize, totalItems, totalPages } = pagination;
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="flex mt-3 flex-col gap-2 items-center sm:items-start sm:flex-row justify-between">
      <p className="text-sm text-muted-foreground">
        Showing {start}-{end} of {totalItems} items
      </p>

      <div className="flex">
        <PaginationSuite currentPage={currentPage} totalPages={totalPages} />
      </div>
    </div>
  );
}
